import { axiosFactory, errorHandler } from '@/configs/axios'

export const StatsReport = {
  api: (params) => {
    const queryParams = new URLSearchParams()

    // Add time range parameters
    if (params.start_range && params.stop_range) {
      queryParams.append('start_range', params.start_range)
      queryParams.append('stop_range', params.stop_range)
    } else if (params.range) {
      // queryParams.append('range', params.range)
    }

    // Add vehicle filter
    if (params.company_vehicle__vehicle__id__in) {
      queryParams.append(
        'company_vehicle__vehicle__id__in',
        params.company_vehicle__vehicle__id__in
      )
    }

    // Add tag filter
    if (params.company_vehicle__company_vehicle_tags__id__in) {
      queryParams.append(
        'company_vehicle__company_vehicle_tags__id__in',
        params.company_vehicle__company_vehicle_tags__id__in
      )
    }

    // Add organization filter
    if (params.company_vehicle__organizations__id__in) {
      queryParams.append(
        'company_vehicle__organizations__id__in',
        params.company_vehicle__organizations__id__in
      )
    }

    const queryString = queryParams.toString()
    const url = queryString
      ? `stats/summaries/?${queryString}`
      : `stats/summaries/`

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const FuelsEfficiencies = {
  api: (params) => {
    const queryParams = new URLSearchParams()

    // Add time range parameters
    if (params.start_range && params.stop_range) {
      queryParams.append('start_range', params.start_range)
      queryParams.append('stop_range', params.stop_range)
    } else if (params.range) {
      // queryParams.append('range', params.range)
    }

    // Add vehicle filter
    if (params.company_vehicle__vehicle__id__in) {
      queryParams.append(
        'company_vehicle__vehicle__id__in',
        params.company_vehicle__vehicle__id__in
      )
    }

    // Add tag filter
    if (params.company_vehicle__company_vehicle_tags__id__in) {
      queryParams.append(
        'company_vehicle__company_vehicle_tags__id__in',
        params.company_vehicle__company_vehicle_tags__id__in
      )
    }

    // Add organization filter
    if (params.company_vehicle__organizations__id__in) {
      queryParams.append(
        'company_vehicle__organizations__id__in',
        params.company_vehicle__organizations__id__in
      )
    }

    const queryString = queryParams.toString()
    const url = queryString
      ? `stats/fuels/efficiencies/?${queryString}`
      : `stats/fuels/efficiencies/`

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const FleetUtilizations = {
  api: (params) => {
    const queryParams = new URLSearchParams()

    // Add time range parameters
    if (params.start_range && params.stop_range) {
      queryParams.append('start_range', params.start_range)
      queryParams.append('stop_range', params.stop_range)
    } else if (params.range) {
      // queryParams.append('range', params.range)
    }

    // Add vehicle filter
    if (params.company_vehicle__vehicle__id__in) {
      queryParams.append(
        'company_vehicle__vehicle__id__in',
        params.company_vehicle__vehicle__id__in
      )
    }

    // Add tag filter
    if (params.company_vehicle__company_vehicle_tags__id__in) {
      queryParams.append(
        'company_vehicle__company_vehicle_tags__id__in',
        params.company_vehicle__company_vehicle_tags__id__in
      )
    }

    // Add organization filter
    if (params.company_vehicle__organizations__id__in) {
      queryParams.append(
        'company_vehicle__organizations__id__in',
        params.company_vehicle__organizations__id__in
      )
    }

    const queryString = queryParams.toString()
    const url = queryString
      ? `stats/fleets/utilizations/?${queryString}`
      : `stats/fleets/utilizations/`

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const StatsCosts = {
  api: (params) => {
    const queryParams = new URLSearchParams()

    // Add time range parameters
    if (params.start_range && params.stop_range) {
      queryParams.append('start_range', params.start_range)
      queryParams.append('stop_range', params.stop_range)
    } else if (params.range) {
      // queryParams.append('range', params.range)
    }

    // Add vehicle filter
    if (params.company_vehicle__vehicle__id__in) {
      queryParams.append(
        'company_vehicle__vehicle__id__in',
        params.company_vehicle__vehicle__id__in
      )
    }

    // Add tag filter
    if (params.company_vehicle__company_vehicle_tags__id__in) {
      queryParams.append(
        'company_vehicle__company_vehicle_tags__id__in',
        params.company_vehicle__company_vehicle_tags__id__in
      )
    }

    // Add organization filter
    if (params.company_vehicle__organizations__id__in) {
      queryParams.append(
        'company_vehicle__organizations__id__in',
        params.company_vehicle__organizations__id__in
      )
    }

    const queryString = queryParams.toString()
    const url = queryString ? `stats/costs/?${queryString}` : `stats/costs/`

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const StatsFences = {
  api: (params) => {
    const queryParams = new URLSearchParams()

    // Add time range parameters
    if (params.start_range && params.stop_range) {
      queryParams.append('start_range', params.start_range)
      queryParams.append('stop_range', params.stop_range)
    } else if (params.range) {
      // queryParams.append('range', params.range)
    }

    // Add vehicle filter
    if (params.company_vehicle__vehicle__id__in) {
      queryParams.append(
        'company_vehicle__vehicle__id__in',
        params.company_vehicle__vehicle__id__in
      )
    }

    // Add tag filter
    if (params.company_vehicle__company_vehicle_tags__id__in) {
      queryParams.append(
        'company_vehicle__company_vehicle_tags__id__in',
        params.company_vehicle__company_vehicle_tags__id__in
      )
    }

    // Add organization filter
    if (params.company_vehicle__organizations__id__in) {
      queryParams.append(
        'company_vehicle__organizations__id__in',
        params.company_vehicle__organizations__id__in
      )
    }

    const queryString = queryParams.toString()
    const url = queryString
      ? `stats/fences/events/?${queryString}`
      : `stats/fences/events/`

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const StatsDriversBehaviours = {
  api: (params) => {
    const queryParams = new URLSearchParams()

    // Add time range parameters
    if (params.start_range && params.stop_range) {
      queryParams.append('start_range', params.start_range)
      queryParams.append('stop_range', params.stop_range)
    } else if (params.range) {
      // queryParams.append('range', params.range)
    }

    // Add vehicle filter
    if (params.company_vehicle__vehicle__id__in) {
      queryParams.append(
        'company_vehicle__vehicle__id__in',
        params.company_vehicle__vehicle__id__in
      )
    }

    // Add tag filter
    if (params.company_vehicle__company_vehicle_tags__id__in) {
      queryParams.append(
        'company_vehicle__company_vehicle_tags__id__in',
        params.company_vehicle__company_vehicle_tags__id__in
      )
    }

    // Add organization filter
    if (params.company_vehicle__organizations__id__in) {
      queryParams.append(
        'company_vehicle__organizations__id__in',
        params.company_vehicle__organizations__id__in
      )
    }

    const queryString = queryParams.toString()
    const url = queryString
      ? `stats/drivers/behaviours/?${queryString}`
      : `stats/drivers/behaviours/`

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
